// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-8 {
  bottom: 2rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-1\\/3 {
  top: 33.333333%;
}
.top-\\[-25px\\] {
  top: -25px;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[-1\\] {
  z-index: -1;
}
.z-\\[45\\] {
  z-index: 45;
}
.z-\\[46\\] {
  z-index: 46;
}
.z-\\[60\\] {
  z-index: 60;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mt-8 {
  margin-top: -2rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-\\[14px\\] {
  margin-left: 14px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-\\[14px\\] {
  margin-right: 14px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.size-10 {
  width: 2.5rem;
  height: 2.5rem;
}
.size-12 {
  width: 3rem;
  height: 3rem;
}
.size-16 {
  width: 4rem;
  height: 4rem;
}
.size-2 {
  width: 0.5rem;
  height: 0.5rem;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.size-8 {
  width: 2rem;
  height: 2rem;
}
.size-\\[12\\.35px\\] {
  width: 12.35px;
  height: 12.35px;
}
.size-\\[130px\\] {
  width: 130px;
  height: 130px;
}
.size-\\[18px\\] {
  width: 18px;
  height: 18px;
}
.size-\\[34px\\] {
  width: 34px;
  height: 34px;
}
.h-1\\/2 {
  height: 50%;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[0\\.1px\\] {
  height: 0.1px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[23px\\] {
  height: 23px;
}
.h-\\[248px\\] {
  height: 248px;
}
.h-\\[250px\\] {
  height: 250px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[33\\.6px\\] {
  height: 33.6px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[450px\\] {
  height: 450px;
}
.h-\\[459px\\] {
  height: 459px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[472px\\] {
  height: 472px;
}
.h-\\[550px\\] {
  height: 550px;
}
.h-\\[650px\\] {
  height: 650px;
}
.h-\\[670px\\] {
  height: 670px;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-\\[720px\\] {
  height: 720px;
}
.h-\\[750px\\] {
  height: 750px;
}
.h-\\[75vh\\] {
  height: 75vh;
}
.h-\\[78vh\\] {
  height: 78vh;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[94\\%\\] {
  height: 94%;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[75vh\\] {
  max-height: 75vh;
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-\\[435px\\] {
  min-height: 435px;
}
.min-h-\\[550px\\] {
  min-height: 550px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: 0px;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-7 {
  width: 1.75rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[11\\%\\] {
  width: 11%;
}
.w-\\[12\\%\\] {
  width: 12%;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[13\\%\\] {
  width: 13%;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[14\\%\\] {
  width: 14%;
}
.w-\\[15\\%\\] {
  width: 15%;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[16\\%\\] {
  width: 16%;
}
.w-\\[166px\\] {
  width: 166px;
}
.w-\\[17\\%\\] {
  width: 17%;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[190px\\] {
  width: 190px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[210px\\] {
  width: 210px;
}
.w-\\[22\\%\\] {
  width: 22%;
}
.w-\\[230px\\] {
  width: 230px;
}
.w-\\[24\\%\\] {
  width: 24%;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[27\\%\\] {
  width: 27%;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[31\\%\\] {
  width: 31%;
}
.w-\\[35\\%\\] {
  width: 35%;
}
.w-\\[36\\%\\] {
  width: 36%;
}
.w-\\[38\\%\\] {
  width: 38%;
}
.w-\\[4\\%\\] {
  width: 4%;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[45\\%\\] {
  width: 45%;
}
.w-\\[47\\%\\] {
  width: 47%;
}
.w-\\[5\\%\\] {
  width: 5%;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[52px\\] {
  width: 52px;
}
.w-\\[53\\%\\] {
  width: 53%;
}
.w-\\[6\\%\\] {
  width: 6%;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[67px\\] {
  width: 67px;
}
.w-\\[7\\%\\] {
  width: 7%;
}
.w-\\[8\\%\\] {
  width: 8%;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[9\\%\\] {
  width: 9%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[96\\%\\] {
  width: 96%;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.min-w-16 {
  min-width: 4rem;
}
.min-w-9 {
  min-width: 2.25rem;
}
.min-w-\\[175px\\] {
  min-width: 175px;
}
.min-w-\\[82px\\] {
  min-width: 82px;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[30\\%\\] {
  --tw-translate-x: -30%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[45\\%\\] {
  --tw-translate-y: -45%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[55\\%\\] {
  --tw-translate-y: -55%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[60\\%\\] {
  --tw-translate-y: -60%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.appearance-none {
  appearance: none;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-6 {
  row-gap: 1.5rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.text-nowrap {
  text-wrap: nowrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[32px\\] {
  border-radius: 32px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-\\[24px\\] {
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r-\\[24px\\] {
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t-\\[24px\\] {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}
.rounded-tr-\\[24px\\] {
  border-top-right-radius: 24px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-\\[1px\\] {
  border-top-width: 1px;
}
.border-none {
  border-style: none;
}
.border-\\[\\#00F4FF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 244 255 / var(--tw-border-opacity));
}
.border-\\[\\#1F1F1F\\] {
  --tw-border-opacity: 1;
  border-color: rgb(31 31 31 / var(--tw-border-opacity));
}
.border-\\[\\#202020\\] {
  --tw-border-opacity: 1;
  border-color: rgb(32 32 32 / var(--tw-border-opacity));
}
.border-\\[\\#292929\\] {
  --tw-border-opacity: 1;
  border-color: rgb(41 41 41 / var(--tw-border-opacity));
}
.border-\\[\\#353535\\] {
  --tw-border-opacity: 1;
  border-color: rgb(53 53 53 / var(--tw-border-opacity));
}
.border-\\[\\#424242\\] {
  --tw-border-opacity: 1;
  border-color: rgb(66 66 66 / var(--tw-border-opacity));
}
.border-\\[\\#646464\\] {
  --tw-border-opacity: 1;
  border-color: rgb(100 100 100 / var(--tw-border-opacity));
}
.border-\\[\\#6E6E6E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(110 110 110 / var(--tw-border-opacity));
}
.border-\\[\\#6c6c6c\\] {
  --tw-border-opacity: 1;
  border-color: rgb(108 108 108 / var(--tw-border-opacity));
}
.border-\\[\\#737B7B\\] {
  --tw-border-opacity: 1;
  border-color: rgb(115 123 123 / var(--tw-border-opacity));
}
.border-\\[\\#7D7D7D\\] {
  --tw-border-opacity: 1;
  border-color: rgb(125 125 125 / var(--tw-border-opacity));
}
.border-\\[\\#7d7d7d\\] {
  --tw-border-opacity: 1;
  border-color: rgb(125 125 125 / var(--tw-border-opacity));
}
.border-\\[\\#9a9999\\] {
  --tw-border-opacity: 1;
  border-color: rgb(154 153 153 / var(--tw-border-opacity));
}
.border-\\[\\#A1A1A1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(161 161 161 / var(--tw-border-opacity));
}
.border-\\[\\#A4F7201F\\] {
  border-color: #A4F7201F;
}
.border-\\[\\#DAFE6A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(218 254 106 / var(--tw-border-opacity));
}
.border-\\[\\#E6E6E6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 230 230 / var(--tw-border-opacity));
}
.border-\\[\\#FFE664\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 230 100 / var(--tw-border-opacity));
}
.border-\\[\\#FFFFFF12\\] {
  border-color: #FFFFFF12;
}
.border-\\[\\#FFFFFF14\\] {
  border-color: #FFFFFF14;
}
.border-\\[\\#FFFFFF1F\\] {
  border-color: #FFFFFF1F;
}
.border-\\[\\#FFFFFF29\\] {
  border-color: #FFFFFF29;
}
.border-\\[\\#FFFFFF3D\\] {
  border-color: #FFFFFF3D;
}
.border-\\[\\#FFFFFF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-tertiary {
  --tw-border-opacity: 1;
  border-color: rgb(218 254 106 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-y-tertiary {
  --tw-border-opacity: 1;
  border-top-color: rgb(218 254 106 / var(--tw-border-opacity));
  border-bottom-color: rgb(218 254 106 / var(--tw-border-opacity));
}
.border-b-\\[\\#373737\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(55 55 55 / var(--tw-border-opacity));
}
.border-b-\\[\\#424242\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(66 66 66 / var(--tw-border-opacity));
}
.border-b-\\[\\#7D7D7D\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(125 125 125 / var(--tw-border-opacity));
}
.border-b-\\[\\#939393\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(147 147 147 / var(--tw-border-opacity));
}
.border-l-\\[\\#7D7D7D\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(125 125 125 / var(--tw-border-opacity));
}
.bg-\\[\\#000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#00F4FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 244 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#00c896\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 200 150 / var(--tw-bg-opacity));
}
.bg-\\[\\#00f2ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 242 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#0A0A0A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity));
}
.bg-\\[\\#101010\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 16 / var(--tw-bg-opacity));
}
.bg-\\[\\#111111\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 17 / var(--tw-bg-opacity));
}
.bg-\\[\\#141414\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 20 20 / var(--tw-bg-opacity));
}
.bg-\\[\\#151515\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 21 / var(--tw-bg-opacity));
}
.bg-\\[\\#191919\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(25 25 25 / var(--tw-bg-opacity));
}
.bg-\\[\\#1C1C1C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 28 / var(--tw-bg-opacity));
}
.bg-\\[\\#1F1F1F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(31 31 31 / var(--tw-bg-opacity));
}
.bg-\\[\\#202020\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 32 / var(--tw-bg-opacity));
}
.bg-\\[\\#232323\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 35 35 / var(--tw-bg-opacity));
}
.bg-\\[\\#242424\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(36 36 36 / var(--tw-bg-opacity));
}
.bg-\\[\\#282828\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 40 40 / var(--tw-bg-opacity));
}
.bg-\\[\\#28A263\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 162 99 / var(--tw-bg-opacity));
}
.bg-\\[\\#2D2D2D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(45 45 45 / var(--tw-bg-opacity));
}
.bg-\\[\\#353535\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(53 53 53 / var(--tw-bg-opacity));
}
.bg-\\[\\#424242\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(66 66 66 / var(--tw-bg-opacity));
}
.bg-\\[\\#555555\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(85 85 85 / var(--tw-bg-opacity));
}
.bg-\\[\\#5DBC55\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(93 188 85 / var(--tw-bg-opacity));
}
.bg-\\[\\#A4F72014\\] {
  background-color: #A4F72014;
}
.bg-\\[\\#A4F720\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(164 247 32 / var(--tw-bg-opacity));
}
.bg-\\[\\#EEF5CE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 245 206 / var(--tw-bg-opacity));
}
.bg-\\[\\#EF4444\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-\\[\\#F24E1E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 78 30 / var(--tw-bg-opacity));
}
.bg-\\[\\#FAFAFA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFE664\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 230 100 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF0A\\] {
  background-color: #FFFFFF0A;
}
.bg-\\[\\#FFFFFF0F\\] {
  background-color: #FFFFFF0F;
}
.bg-\\[\\#FFFFFF3D\\] {
  background-color: #FFFFFF3D;
}
.bg-\\[\\#\\] {
  background-color: #;
}
.bg-\\[\\#b2b2b2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(178 178 178 / var(--tw-bg-opacity));
}
.bg-\\[\\#b2c1c1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(178 193 193 / var(--tw-bg-opacity));
}
.bg-\\[\\#b8e834\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(184 232 52 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-emerald-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / var(--tw-bg-opacity));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-gray-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.bg-neutral-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.bg-red-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity));
}
.bg-tertiary {
  --tw-bg-opacity: 1;
  background-color: rgb(218 254 106 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-100 {
  --tw-bg-opacity: 1;
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.bg-cover {
  background-size: cover;
}
.bg-clip-text {
  background-clip: text;
}
.bg-center {
  background-position: center;
}
.bg-left {
  background-position: left;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-none {
  object-fit: none;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-20 {
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[6px\\] {
  padding-bottom: 6px;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[35\\%\\] {
  padding-top: 35%;
}
.pt-\\[5px\\] {
  padding-top: 5px;
}
.pt-\\[6px\\] {
  padding-top: 6px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11\\.732px\\] {
  font-size: 11.732px;
}
.text-\\[12\\.36px\\] {
  font-size: 12.36px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14\\.5px\\] {
  font-size: 14.5px;
}
.text-\\[14\\.74px\\] {
  font-size: 14.74px;
}
.text-\\[14\\.83px\\] {
  font-size: 14.83px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15\\.27px\\] {
  font-size: 15.27px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18\\.5px\\] {
  font-size: 18.5px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[22\\.6px\\] {
  font-size: 22.6px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[38px\\] {
  font-size: 38px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-\\[42px\\] {
  font-size: 42px;
}
.text-\\[48px\\] {
  font-size: 48px;
}
.text-\\[80px\\] {
  font-size: 80px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extralight {
  font-weight: 200;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-\\[24px\\] {
  line-height: 24px;
}
.leading-none {
  line-height: 1;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-1\\] {
  letter-spacing: -1;
}
.text-\\[\\#0A0A0A\\] {
  --tw-text-opacity: 1;
  color: rgb(10 10 10 / var(--tw-text-opacity));
}
.text-\\[\\#111111\\] {
  --tw-text-opacity: 1;
  color: rgb(17 17 17 / var(--tw-text-opacity));
}
.text-\\[\\#28A263\\] {
  --tw-text-opacity: 1;
  color: rgb(40 162 99 / var(--tw-text-opacity));
}
.text-\\[\\#414141\\] {
  --tw-text-opacity: 1;
  color: rgb(65 65 65 / var(--tw-text-opacity));
}
.text-\\[\\#555555\\] {
  --tw-text-opacity: 1;
  color: rgb(85 85 85 / var(--tw-text-opacity));
}
.text-\\[\\#5865F2\\] {
  --tw-text-opacity: 1;
  color: rgb(88 101 242 / var(--tw-text-opacity));
}
.text-\\[\\#5F6868\\] {
  --tw-text-opacity: 1;
  color: rgb(95 104 104 / var(--tw-text-opacity));
}
.text-\\[\\#646464\\] {
  --tw-text-opacity: 1;
  color: rgb(100 100 100 / var(--tw-text-opacity));
}
.text-\\[\\#686B6E\\] {
  --tw-text-opacity: 1;
  color: rgb(104 107 110 / var(--tw-text-opacity));
}
.text-\\[\\#686F6F\\] {
  --tw-text-opacity: 1;
  color: rgb(104 111 111 / var(--tw-text-opacity));
}
.text-\\[\\#737B7B\\] {
  --tw-text-opacity: 1;
  color: rgb(115 123 123 / var(--tw-text-opacity));
}
.text-\\[\\#7D7D7D\\] {
  --tw-text-opacity: 1;
  color: rgb(125 125 125 / var(--tw-text-opacity));
}
.text-\\[\\#7b7B7B\\] {
  --tw-text-opacity: 1;
  color: rgb(123 123 123 / var(--tw-text-opacity));
}
.text-\\[\\#7d7d7d\\] {
  --tw-text-opacity: 1;
  color: rgb(125 125 125 / var(--tw-text-opacity));
}
.text-\\[\\#808080\\] {
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity));
}
.text-\\[\\#868686\\] {
  --tw-text-opacity: 1;
  color: rgb(134 134 134 / var(--tw-text-opacity));
}
.text-\\[\\#929292\\] {
  --tw-text-opacity: 1;
  color: rgb(146 146 146 / var(--tw-text-opacity));
}
.text-\\[\\#9B9B9B\\] {
  --tw-text-opacity: 1;
  color: rgb(155 155 155 / var(--tw-text-opacity));
}
.text-\\[\\#9b9b9b\\] {
  --tw-text-opacity: 1;
  color: rgb(155 155 155 / var(--tw-text-opacity));
}
.text-\\[\\#A1A1A1\\] {
  --tw-text-opacity: 1;
  color: rgb(161 161 161 / var(--tw-text-opacity));
}
.text-\\[\\#A4F720\\] {
  --tw-text-opacity: 1;
  color: rgb(164 247 32 / var(--tw-text-opacity));
}
.text-\\[\\#AFAFAF\\] {
  --tw-text-opacity: 1;
  color: rgb(175 175 175 / var(--tw-text-opacity));
}
.text-\\[\\#BFBFBF\\] {
  --tw-text-opacity: 1;
  color: rgb(191 191 191 / var(--tw-text-opacity));
}
.text-\\[\\#C4C4C4\\] {
  --tw-text-opacity: 1;
  color: rgb(196 196 196 / var(--tw-text-opacity));
}
.text-\\[\\#C5C5C5\\] {
  --tw-text-opacity: 1;
  color: rgb(197 197 197 / var(--tw-text-opacity));
}
.text-\\[\\#F24E1E\\] {
  --tw-text-opacity: 1;
  color: rgb(242 78 30 / var(--tw-text-opacity));
}
.text-\\[\\#FFFFFFB2\\] {
  color: #FFFFFFB2;
}
.text-\\[\\#FFFFFF\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-\\[\\#fff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-\\[rgb\\(196\\2c 196\\2c 196\\)\\] {
  --tw-text-opacity: 1;
  color: rgb(196 196 196 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-body {
  --tw-text-opacity: 1;
  color: rgb(175 175 175 / var(--tw-text-opacity));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-heading {
  --tw-text-opacity: 1;
  color: rgb(196 196 196 / var(--tw-text-opacity));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-tertiary {
  --tw-text-opacity: 1;
  color: rgb(218 254 106 / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}
.text-opacity-20 {
  --tw-text-opacity: 0.2;
}
.text-opacity-80 {
  --tw-text-opacity: 0.8;
}
.underline {
  text-decoration-line: underline;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.underline-offset-\\[12px\\] {
  text-underline-offset: 12px;
}
.opacity-100 {
  opacity: 1;
}
.opacity-15 {
  opacity: 0.15;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-45 {
  opacity: 0.45;
}
.opacity-50 {
  opacity: 0.5;
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-2xl {
  --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-xl {
  --tw-drop-shadow: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.scrollbar::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
.scrollbar::-webkit-scrollbar-track {
    border-radius: 10vh;
  }
.scrollbar::-webkit-scrollbar-thumb {
    background: #504949;
    border-radius: 100vh;
    border: 3px solid #504949;
    scroll-padding-top: 6px;
  }
.scrollbar::-webkit-scrollbar-thumb:hover {
    background: #c0a0b9;
  }

body {
  background-color: #000;
}

.ant-empty-description {
  color: white !important;
}

.ant-tabs-tab {
  color: white !important;
}

.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: rgb(218 254 106) !important;
}

.ant-tabs .ant-tabs-ink-bar {
  background-color: rgb(218 254 106) !important;
}

.ant-collapse {
  border: none !important;
}

.ant-collapse-item {
  border: none !important;
  /* border: 1px solid #1F1F1F !important; */
}

.ant-collapse-header {
  color: #fff !important;
  font-weight: bold;
}

.ant-collapse-content {
  background-color: transparent !important;
  color: #fff !important;
  font-weight: lighter;
  border: none !important;
  border-top: 1px solid #ffffff1f !important;
}
.blur {
  /* -webkit-backdrop-filter: blur(10px); */
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
.placeholder\\:text-\\[\\#5a5a5a\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(90 90 90 / var(--tw-text-opacity));
}
.placeholder\\:text-\\[\\#7d7d7d\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(125 125 125 / var(--tw-text-opacity));
}
.placeholder\\:text-\\[\\#9B9B9B\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(155 155 155 / var(--tw-text-opacity));
}
.placeholder\\:text-\\[\\#9b9b9b\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(155 155 155 / var(--tw-text-opacity));
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:start-\\[2px\\]::after {
  content: var(--tw-content);
  inset-inline-start: 2px;
}
.after\\:top-\\[2px\\]::after {
  content: var(--tw-content);
  top: 2px;
}
.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}
.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}
.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}
.after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.checked\\:border-0:checked {
  border-width: 0px;
}
.checked\\:bg-tertiary:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(218 254 106 / var(--tw-bg-opacity));
}
.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-tertiary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(218 254 106 / var(--tw-border-opacity));
}
.hover\\:bg-\\[\\#191919\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(25 25 25 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#DAFE6A\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(218 254 106 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#aad13f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(170 209 63 / var(--tw-bg-opacity));
}
.hover\\:font-semibold:hover {
  font-weight: 600;
}
.hover\\:text-\\[\\#DAFE6A\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(218 254 106 / var(--tw-text-opacity));
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.hover\\:text-tertiary:hover {
  --tw-text-opacity: 1;
  color: rgb(218 254 106 / var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:drop-shadow-md:hover {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}
.disabled\\:bg-\\[\\#737B7B\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(115 123 123 / var(--tw-bg-opacity));
}
.disabled\\:bg-\\[\\#9ca88a\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(156 168 138 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:block {
  display: block;
}
.peer:checked ~ .peer-checked\\:bg-\\[\\#E83838\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 56 56 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:bg-tertiary {
  --tw-bg-opacity: 1;
  background-color: rgb(218 254 106 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:after\\:bg-black::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.peer:focus ~ .peer-focus\\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.peer:focus ~ .peer-focus\\:ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.peer:focus ~ .peer-focus\\:ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity));
}
.peer:focus ~ .peer-focus\\:ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.peer:focus ~ .checked\\:peer-focus\\:ring-black:checked {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}
@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:transition-none {
    transition-property: none;
  }

  .motion-reduce\\:hover\\:transform-none:hover {
    transform: none;
  }
}
@media (min-width: 340px) {

  .min-\\[340px\\]\\:w-\\[300px\\] {
    width: 300px;
  }

  .min-\\[340px\\]\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
}
@media (min-width: 380px) {

  .min-\\[380px\\]\\:h-\\[250px\\] {
    height: 250px;
  }

  .min-\\[380px\\]\\:h-\\[500px\\] {
    height: 500px;
  }
}
@media (min-width: 450px) {

  .min-\\[450px\\]\\:flex {
    display: flex;
  }

  .min-\\[450px\\]\\:hidden {
    display: none;
  }
}
@media (min-width: 470px) {

  .min-\\[470px\\]\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .min-\\[470px\\]\\:text-\\[16\\.04px\\] {
    font-size: 16.04px;
  }
}
@media (min-width: 640px) {

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:-mt-2 {
    margin-top: -0.5rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-5 {
    margin-top: 1.25rem;
  }

  .sm\\:h-\\[480px\\] {
    height: 480px;
  }

  .sm\\:h-\\[84px\\] {
    height: 84px;
  }

  .sm\\:w-1\\/3 {
    width: 33.333333%;
  }

  .sm\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .sm\\:w-\\[450px\\] {
    width: 450px;
  }

  .sm\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .sm\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .sm\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .sm\\:w-fit {
    width: -moz-fit-content;
    width: fit-content;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:justify-evenly {
    justify-content: space-evenly;
  }

  .sm\\:gap-x-8 {
    column-gap: 2rem;
  }

  .sm\\:gap-y-0 {
    row-gap: 0px;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:pt-0 {
    padding-top: 0px;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 768px) {

  .md\\:relative {
    position: relative;
  }

  .md\\:order-2 {
    order: 2;
  }

  .md\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .md\\:ml-2 {
    margin-left: 0.5rem;
  }

  .md\\:ml-6 {
    margin-left: 1.5rem;
  }

  .md\\:mr-\\[58px\\] {
    margin-right: 58px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-24 {
    margin-top: 6rem;
  }

  .md\\:mt-6 {
    margin-top: 1.5rem;
  }

  .md\\:mt-auto {
    margin-top: auto;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline-block {
    display: inline-block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-1\\/2 {
    height: 50%;
  }

  .md\\:h-16 {
    height: 4rem;
  }

  .md\\:h-\\[316px\\] {
    height: 316px;
  }

  .md\\:h-\\[400px\\] {
    height: 400px;
  }

  .md\\:h-\\[472px\\] {
    height: 472px;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-3\\/4 {
    width: 75%;
  }

  .md\\:w-\\[12\\%\\] {
    width: 12%;
  }

  .md\\:w-\\[15\\%\\] {
    width: 15%;
  }

  .md\\:w-\\[28\\%\\] {
    width: 28%;
  }

  .md\\:w-\\[42\\%\\] {
    width: 42%;
  }

  .md\\:w-\\[528px\\] {
    width: 528px;
  }

  .md\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-md {
    max-width: 28rem;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-y-0 {
    row-gap: 0px;
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:pb-12 {
    padding-bottom: 3rem;
  }

  .md\\:pr-8 {
    padding-right: 2rem;
  }

  .md\\:pt-4 {
    padding-top: 1rem;
  }

  .md\\:pt-8 {
    padding-top: 2rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:text-right {
    text-align: right;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .md\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .md\\:text-\\[42px\\] {
    font-size: 42px;
  }

  .md\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .md\\:text-\\[96px\\] {
    font-size: 96px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:absolute {
    position: absolute;
  }

  .lg\\:ml-4 {
    margin-left: 1rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-24 {
    margin-top: 6rem;
  }

  .lg\\:mt-36 {
    margin-top: 9rem;
  }

  .lg\\:mt-6 {
    margin-top: 1.5rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:h-screen {
    height: 100vh;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }

  .lg\\:w-1\\/4 {
    width: 25%;
  }

  .lg\\:w-\\[32\\%\\] {
    width: 32%;
  }

  .lg\\:w-\\[34\\%\\] {
    width: 34%;
  }

  .lg\\:w-\\[35\\%\\] {
    width: 35%;
  }

  .lg\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .lg\\:w-\\[600px\\] {
    width: 600px;
  }

  .lg\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .lg\\:w-\\[96\\%\\] {
    width: 96%;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-x-4 {
    column-gap: 1rem;
  }

  .lg\\:rounded-tr-\\[24px\\] {
    border-top-right-radius: 24px;
  }

  .lg\\:p-12 {
    padding: 3rem;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .lg\\:text-\\[64px\\] {
    font-size: 64px;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:font-normal {
    font-weight: 400;
  }

  .lg\\:leading-\\[65px\\] {
    line-height: 65px;
  }
}
@media (min-width: 1280px) {

  .xl\\:left-0 {
    left: 0px;
  }

  .xl\\:right-\\[2\\%\\] {
    right: 2%;
  }

  .xl\\:right-\\[4\\%\\] {
    right: 4%;
  }

  .xl\\:ml-\\[12\\%\\] {
    margin-left: 12%;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:h-\\[80\\%\\] {
    height: 80%;
  }

  .xl\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .xl\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
@media (min-width: 1355px) {

  .min-\\[1355px\\]\\:w-\\[88\\%\\] {
    width: 88%;
  }
}
@media (min-width: 1380px) {

  .min-\\[1380px\\]\\:flex-row {
    flex-direction: row;
  }
}
@media (min-width: 1470px) {

  .min-\\[1470px\\]\\:right-\\[4\\%\\] {
    right: 4%;
  }

  .min-\\[1470px\\]\\:right-\\[7\\%\\] {
    right: 7%;
  }

  .min-\\[1470px\\]\\:ml-\\[15\\%\\] {
    margin-left: 15%;
  }

  .min-\\[1470px\\]\\:h-\\[85\\%\\] {
    height: 85%;
  }

  .min-\\[1470px\\]\\:w-\\[28\\%\\] {
    width: 28%;
  }
}
@media (min-width: 1571px) {

  .min-\\[1571px\\]\\:w-\\[80\\%\\] {
    width: 80%;
  }
}
@media (min-width: 1662px) {

  .min-\\[1662px\\]\\:right-\\[7\\%\\] {
    right: 7%;
  }
}
.peer:checked ~ .rtl\\:peer-checked\\:after\\:-translate-x-full:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (prefers-color-scheme: dark) {

  .dark\\:border-gray-600 {
    --tw-border-opacity: 1;
    border-color: rgb(75 85 99 / var(--tw-border-opacity));
  }

  .dark\\:bg-\\[\\#5DBC55\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(93 188 85 / var(--tw-bg-opacity));
  }

  .dark\\:bg-\\[\\#646464\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(100 100 100 / var(--tw-bg-opacity));
  }

  .peer:focus ~ .dark\\:peer-focus\\:ring-white {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
  }

  .peer:focus ~ .dark\\:checked\\:peer-focus\\:ring-black:checked {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAGjB;IACE,UAAU;IACV,WAAW;EACb;AAEA;IACE,mBAAmB;EACrB;AAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,uBAAuB;EACzB;AAEA;IACE,mBAAmB;EACrB;;AAGF;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;EACE,yCAAyC;EACzC,mCAA2B;UAA3B,2BAA2B;AAC7B;AAtEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA,sBAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA,wBAuEA;EAvEA,wDAuEA;EAvEA;AAuEA;AAvEA;EAAA,gBAuEA;EAvEA;AAuEA;AAvEA;EAAA;AAuEA;AAvEA;EAAA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA;AAuEA;AAvEA;EAAA,sBAuEA;EAvEA;AAuEA;AAvEA;EAAA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA;AAuEA;AAvEA;EAAA,mGAuEA;EAvEA;AAuEA;AAvEA;EAAA,sBAuEA;EAvEA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA;AAuEA;AAvEA;EAAA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA,sBAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA,sBAuEA;EAvEA;AAuEA;AAvEA;EAAA,0BAuEA;EAvEA,kBAuEA;EAvEA;AAuEA;AAvEA;EAAA,8BAuEA;EAvEA;AAuEA;AAvEA;EAAA,2GAuEA;EAvEA,yGAuEA;EAvEA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;EAAA,oBAuEA;EAvEA;AAuEA;AAvEA;;EAAA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;;EAvEA;IAAA,iBAuEA;IAvEA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;AAAA;AAvEA;;EAAA;IAAA,eAuEA;IAvEA;EAuEA;;EAvEA;IAAA;EAuEA;AAAA;AAvEA;;EAAA;IAAA,gBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,iBAuEA;IAvEA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,uBAuEA;IAvEA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,qBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,oBAuEA;IAvEA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,iBAuEA;IAvEA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,iBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,mBAuEA;IAvEA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,iBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,mBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,iBAuEA;IAvEA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,eAuEA;IAvEA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,eAuEA;IAvEA;EAuEA;;EAvEA;IAAA,mBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA,qBAuEA;IAvEA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;;EAvEA;IAAA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;AAAA;AAvEA;;EAAA;IAAA;EAuEA;AAAA;AAvEA;EAAA,0BAuEA;EAvEA,uBAuEA;EAvEA;AAuEA;AAvEA;;EAAA;IAAA,sBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,kBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,oBAuEA;IAvEA;EAuEA;;EAvEA;IAAA,oBAuEA;IAvEA;EAuEA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer utilities {\n  .scrollbar::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n  }\n\n  .scrollbar::-webkit-scrollbar-track {\n    border-radius: 10vh;\n  }\n\n  .scrollbar::-webkit-scrollbar-thumb {\n    background: #504949;\n    border-radius: 100vh;\n    border: 3px solid #504949;\n    scroll-padding-top: 6px;\n  }\n\n  .scrollbar::-webkit-scrollbar-thumb:hover {\n    background: #c0a0b9;\n  }\n}\n\nbody {\n  background-color: #000;\n}\n\n.ant-empty-description {\n  color: white !important;\n}\n\n.ant-tabs-tab {\n  color: white !important;\n}\n\n.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: rgb(218 254 106) !important;\n}\n\n.ant-tabs .ant-tabs-ink-bar {\n  background-color: rgb(218 254 106) !important;\n}\n\n.ant-collapse {\n  border: none !important;\n}\n\n.ant-collapse-item {\n  border: none !important;\n  /* border: 1px solid #1F1F1F !important; */\n}\n\n.ant-collapse-header {\n  color: #fff !important;\n  font-weight: bold;\n}\n\n.ant-collapse-content {\n  background-color: transparent !important;\n  color: #fff !important;\n  font-weight: lighter;\n  border: none !important;\n  border-top: 1px solid #ffffff1f !important;\n}\n.blur {\n  /* -webkit-backdrop-filter: blur(10px); */\n  backdrop-filter: blur(10px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
